import Vue from 'vue';
import { get } from 'lodash';

export function getRequestErrorMessage(err, defaultMessage) {
  if (err.response?.status === 429) {
    return err.response.data;
  }
  return get(err, 'response.data.message', defaultMessage);
}

export function handleReqErrorWithToast(err, defaultMessage) {
  const errorText = getRequestErrorMessage(err, defaultMessage);
  Vue.$toast.error(errorText);
}
